import { createEventBus } from 'n8n-design-system';

export const sourceControlEventBus = createEventBus();
